/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusSuccessDto } from '../../models/lexplus-success-dto';

export interface UploadsControllerDeleteDateiV1$Params {
  stagingId: string;
  kundeId: number;
}

export function uploadsControllerDeleteDateiV1(http: HttpClient, rootUrl: string, params: UploadsControllerDeleteDateiV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusSuccessDto>> {
  const rb = new RequestBuilder(rootUrl, uploadsControllerDeleteDateiV1.PATH, 'delete');
  if (params) {
    rb.path('stagingId', params.stagingId, {});
    rb.query('kundeId', params.kundeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusSuccessDto>;
    })
  );
}

uploadsControllerDeleteDateiV1.PATH = '/v1/uploads/datei/{stagingId}';
